import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App.js";
import "./styles/tokens.css";
import { initLogger, logError } from "./lib/logger.js";
import { getAccessToken } from "./lib/api.js";
import { installConsoleErrorBuffer } from "./lib/issueContext.js";
import { reloadOnceForStaleChunk } from "./lib/lazyWithRetry.js";

initLogger(getAccessToken);
installConsoleErrorBuffer();

// Vite fires this when a preloaded chunk 404s (stale tab after a deploy).
window.addEventListener("vite:preloadError", (e) => {
  if (reloadOnceForStaleChunk()) e.preventDefault();
});

window.addEventListener("error", (e) => {
  logError("window.error", e.error ?? e.message, {
    filename: e.filename,
    lineno:   e.lineno,
    colno:    e.colno,
  });
});

window.addEventListener("unhandledrejection", (e) => {
  logError("window.unhandledrejection", e.reason);
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
